import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
/**
 * Pads the and returns a readable hh:mm format
 */

export function toTimeStr(hours, minutes) {
  var pad = function pad(i) {
    return String(parseInt(i)).padStart(2, '0');
  };
  return "".concat(pad(hours), ":").concat(pad(minutes));
}
export default toTimeStr;